<template>
  <div class="home-carousel">
    <div id="carouselExampleIndicators" class="carousel slide carouse-inner-web" data-ride="carousel" data-interval="6000">
      <ol class="carousel-indicators">
        <li data-target="#carouselExampleIndicators" data-slide-to="0"  class="active"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="3"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="4"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="5"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="6"></li>
      </ol>
      <div class="carousel-inner">
      <!--  <div class="carousel-item active"  onclick="location.href='http://hdxu.cn/dwQ1B'"> -->
      <!--    <img class="d-block w-100" src="../../assets/home/banner_new_0.jpg" alt="First slide"> -->
      <!--    <div class="home-carousel-caption d-none d-md-block"> -->
      <!--    </div> -->
     <!--   </div> -->
        <div class="carousel-item active" @click="toQstationIntroduce">
          <img class="d-block w-100" src="../../assets/home/banner_new_7.png" alt="Second slide">
          <div class="home-carousel-caption d-none d-md-block">
            <div class="home-carousel-title">{{ $t("carousel.title7") }}</div>
            <div class="home-carouse-content">{{ $t("carousel.subtitle7") }}</div>
            <button class="home-carouse-button home-carouse-button-text" >{{ $t("carousel.button1") }}</button>
          </div>
        </div>
        <div class="carousel-item" @click="toPWmatIntroduce">
          <img class="d-block w-100" src="../../assets/home/banner_new_1.png" alt="Second slide">
          <div class="home-carousel-caption d-none d-md-block">
            <div class="home-carousel-title">{{ $t("carousel.title1") }}</div>
            <div class="home-carouse-content">{{ $t("carousel.subtitle1") }}</div>
            <button class="home-carouse-button home-carouse-button-text" >{{ $t("carousel.button1") }}</button>
          </div>
        </div>
        <div class="carousel-item" @click="toPWmatIntroduce">
          <img class="d-block w-100" src="../../assets/home/banner_new_2.png" alt="Third slide">
          <div class="home-carousel-caption d-none d-md-block">
            <div class="home-carousel-title">{{ $t("carousel.title2") }}</div>
            <div class="home-carouse-content">Fast HSE、Electron-Phonon Coupling、rt-TDDFT、NAMD、Solvent Model、Charge Patching Method</div>
            <button class="home-carouse-button home-carouse-button-text">{{ $t("carousel.button1") }}</button>
          </div>
        </div>
        <div class="carousel-item"  onclick="location.href='https://mcloud.lonxun.com'">
          <img class="d-block w-100" src="../../assets/home/banner_new_3.png" alt="First slide">
          <div class="home-carousel-caption d-none d-md-block">
            <div class="home-carousel-title">{{ $t("carousel.title3") }}</div>
            <div class="home-carouse-content">{{ $t("carousel.subtitle3") }}</div>
            <button class="home-carouse-button home-carouse-button-text">{{ $t("carousel.button3") }}</button>
          </div>
        </div>
        <div class="carousel-item" @click="toMLFFIntroduce">
          <img class="d-block w-100" src="../../assets/home/banner_new_4.png" alt="Third slide">
          <div class="home-carousel-caption d-none d-md-block">
            <div class="home-carousel-title">{{ $t("carousel.title4") }}</div>
            <div class="home-carouse-content">{{ $t("carousel.subtitle4") }}</div>
            <button class="home-carouse-button home-carouse-button-text">{{ $t("carousel.button1") }}</button>
          </div>
        </div>
        <div class="carousel-item" @click="toPWMGUIIntroduce">
          <img class="d-block w-100" src="../../assets/home/banner_new_5.png" alt="Third slide">
          <div class="home-carousel-caption d-none d-md-block">
            <div class="home-carousel-title">{{ $t("carousel.title5") }}</div>
            <div class="home-carouse-content">{{ $t("carousel.subtitle5") }}</div>
            <button class="home-carouse-button home-carouse-button-text">{{ $t("carousel.button1") }}</button>
          </div>
        </div>
        <div class="carousel-item" @click="toQStudioIntroduce">
          <img class="d-block w-100" src="../../assets/home/banner_new_6.png" alt="Third slide">
          <div class="home-carousel-caption d-none d-md-block">
            <div class="home-carousel-title">{{ $t("carousel.title6") }}</div>
            <div class="home-carouse-content">{{ $t("carousel.subtitle6") }}</div>
            <button class="home-carouse-button home-carouse-button-text">{{ $t("carousel.button1") }}</button>
          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
  export default {
    name: "HomeCarousel",
    methods:{
      toPWmatIntroduce(){
        this.$router.push({ name: 'PWmatIntroduce'})
      },
      toMLFFIntroduce(){
        this.$router.push({ name: 'MLFFIntroduce'})
      },
      toPWMGUIIntroduce(){
        this.$router.push({ name: 'PWMGUIIntroduce'})
      },
      toQStudioIntroduce(){
        this.$router.push({ name: 'QStudioIntroduce'})
      },
      toQstationIntroduce(){
        this.$router.push({ name: 'Integration'})
      },
    }
  }
</script>

<style scoped>
  .home-carousel{
    margin-top: 70px;
  }
  .home-carousel-caption {
    position: absolute;
    right: 15%;
    top: 20%;
    left: 15%;
    z-index: 10;
    color: #fff;
    text-align: center;
  }
  .home-carousel-title{
    font-size: 48px;
    font-family:PingFangSC-Semibold,sans-serif
  }
  .home-carouse-content{
    font-size: 22px;
    font-family: PingFangSC-Light,sans-serif;
    margin-top: 16px;
  }
  .home-carouse-button{
    border: 2px solid #ffffff;
    background-color: rgb(255,255,255,0.2) ;
    margin-top: 50px;
    width: 340px;
    height: 55px;
    cursor: pointer;
  }
  .home-carouse-button:hover,
  .home-carouse-button:active,
  .home-carouse-button:focus{
    box-shadow:none !important;
    outline:none !important;
  }
  .home-carouse-button-text{
    color: #ffffff;
    font-family: PingFangSC-Light,sans-serif;
    font-size: 24px;
  }
  .carousel-item{
    cursor: pointer;
  }
  .carouse-inner-mobile{
    display: none;
  }

  @media (max-width: 470px) {

    .home-carousel-title{
      font-size: 18px;
    }
    .home-carouse-content{
      font-size: 10px;
      margin-top: 10px;
    }
    .home-carouse-button{
      display: none;
    }
    .carouse-inner-web{
      display: none;
    }
    .carouse-inner-mobile{
      display: inline;
    }
    .carousel-indicators {
      bottom: 0;
    }
  }

  @media (min-width: 470px) and  (max-width: 576px) {

    .home-carousel-title{
      font-size: 24px;
    }
    .home-carouse-content{
      font-size: 14px;
      margin-top: 10px;
    }
    .home-carouse-button{
      display: none;
    }
    .carouse-inner-web{
      display: none;
    }
    .carouse-inner-mobile{
      display: inline;
    }
  }

  @media (min-width: 576px) and  (max-width: 768px) {

    .home-carousel-title{
      font-size: 32px;
    }
    .home-carouse-content{
      font-size: 16px;
    }
    .home-carouse-button{
      display: none;
    }
    .carouse-inner-web{
      display: none;
    }
    .carouse-inner-mobile{
      display: inline;
    }
  }

  @media (min-width: 768px) and  (max-width: 900px) {

    .home-carousel-title{
      font-size: 34px;
    }
    .home-carouse-content{
      font-size: 16px;
    }
    .home-carouse-button{
      display: none;
    }
  }

  @media (min-width: 900px) and (max-width: 1150px) {

    .home-carousel-title{
      font-size: 40px;
    }
    .home-carouse-content{
      font-size: 20px;
    }
    .home-carouse-button{
      display: none;
    }
  }

  @media (min-width: 1150px) and (max-width: 1440px) {

    .home-carouse-button{
      display: none;
    }
  }

  @media (min-width: 1440px) {

  }
</style>
